import instanceAxios from '../config/api'
import { Action } from '../types/actionTypes'
import { Audit } from '../types/auditTypes'
import { Incident } from '../types/incidentTypes'
import { Risque } from '../types/risqueTypes'
import { SecurityCheckResponse } from '../types/securityCheckFamilysTypes'
import {
  AverageActionsForRelatedControlsResponse,
  AverageCostForRelatedControls,
  AverageSCScore,
  CountDoneActionsForRelatedControlsResponse,
  CountDoneActionsForSecurityControlResponse,
  CountInProgressActionsForSecurityControlResponse,
  CountOtherActionsForRelatedControlsResponse,
  CountOtherActionsForSecurityControlResponse,
  GlobalAverageActionsPerSecurityControlResponse,
  InProgressActionsForRelatedControlsResponse,
  LateRateForRelatedControls,
  RelatedControlsActionsCosts,
  RelatedControlsCostsResponse,
  RelatedControlsTree,
  SecurityControlResponse,
  SecurityControls,
  securityControlResponse,
} from '../types/securityControls'
const API_URL = '/securityControls'

export const calculateGlobalAverageActionsPerSecurityControl = async () => {
  try {
    const response =
      await instanceAxios.get<GlobalAverageActionsPerSecurityControlResponse>(
        `${API_URL}/calculateGlobalAverageActionsPerSecurityControl`
      )
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate global average.')
  }
}

export const getSecurityISOApi = async ({
  page,
  pageSize,
  language,
}: {
  page?: number
  pageSize?: number
  language?: string
}) => {
  try {
    const response = await instanceAxios.get<securityControlResponse>(
      `${API_URL}/byISOSource`,
      {
        params: {
          page,
          pageSize,
          language,
        },
      }
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SEcurity ISO.')
  }
}
export const getSecurityControlByIdApi = async (id: string) => {
  try {
    const response = await instanceAxios.get<SecurityControls>(
      `${API_URL}/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch security control by ID.')
  }
}

export const getAllSecurityControls = async ({
  page,
  pageSize,
}: {
  page?: number
  pageSize?: number
}) => {
  try {
    const response = await instanceAxios.get<securityControlResponse>(
      `securityControls/`,
      {
        params: {
          page,
          pageSize,
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SEcurity ISO.')
  }
}
export const getwithSCScores = async (
  language?: string
): Promise<SecurityCheckResponse> => {
  try {
    const response = await instanceAxios.get<SecurityCheckResponse>(
      `securityControls/withSCScores`,
      {
        params: { language },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to get the List of Security Control with Scores')
  }
}

export const getSecurityNISTApi = async ({
  page,
  pageSize,
  language,
}: {
  page?: number
  pageSize?: number
  language?: string
}) => {
  try {
    const response = await instanceAxios.get<securityControlResponse>(
      `securityControls/byNISTSource`,
      {
        params: {
          page,
          pageSize,
          language,
        },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch SecurityCheckFamily ISO.')
  }
}
export const getActionsFromRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<Action[]>(
      `securityControls/getActionsFromRelatedControls/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch actions from related controls.')
  }
}
export const getRisksFromRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<Risque[]>(
      `${API_URL}/getRisksFromRelatedControls/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch risks from related controls.')
  }
}
export const getIncidentsFromRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<Incident[]>(
      `${API_URL}/getIncidentsFromRelatedControls/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch incidents from related controls.')
  }
}
export const getAuditsFromRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<Audit[]>(
      `${API_URL}/getAuditsFromRelatedControls/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch audits from related controls.')
  }
}
export const calculateAverageActionsForRelatedControls = async (
  id: string
): Promise<AverageActionsForRelatedControlsResponse> => {
  try {
    const response =
      await instanceAxios.get<AverageActionsForRelatedControlsResponse>(
        `${API_URL}/calculateAverageActionsForRelatedControls/${id}`
      )
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate average actions for related controls.')
  }
}
export const calculateAverageCostForRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<{
      data: AverageCostForRelatedControls
    }>(`${API_URL}/calculateAverageCostForRelatedControls/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to calculate average cost for related controls.')
  }
}
export const calculateRelatedControlsActionsCosts = async (id: string) => {
  try {
    const response = await instanceAxios.get<{
      data: RelatedControlsActionsCosts
    }>(`${API_URL}/calculateRelatedControlsActionsCosts/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error(
      'Failed to calculate total cost for related controls actions.'
    )
  }
}
export const calculateRelatedControlsCosts = async (
  id: string
): Promise<RelatedControlsCostsResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: RelatedControlsCostsResponse
    }>(`${API_URL}/calculateRelatedControlsCosts/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to calculate related controls costs.')
  }
}
export const countInProgressActionsForRelatedControls = async (
  id: string
): Promise<InProgressActionsForRelatedControlsResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: InProgressActionsForRelatedControlsResponse
    }>(`${API_URL}/countInProgressActionsForRelatedControls/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to fetch in-progress actions for related controls.')
  }
}
export const getRelatedControlsTreeByFamilyId = async (
  id: string
): Promise<RelatedControlsTree> => {
  try {
    const response = await instanceAxios.get<{
      relatedTree: RelatedControlsTree
    }>(`${API_URL}/getRelatedControlsTreeByFamilyId/${id}`)
    return response.data.relatedTree
  } catch (error) {
    throw new Error('Failed to fetch related controls tree.')
  }
}
export const getAverageSCScoreFromRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<AverageSCScore>(
      `${API_URL}/getAverageSCScoreFromRelatedControls/${id}`
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch average SCScore from related controls.')
  }
}
export const calculateLateRateForRelatedControls = async (id: string) => {
  try {
    const response = await instanceAxios.get<{
      data: LateRateForRelatedControls
    }>(`${API_URL}/calculateLateRateForRelatedControls/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to calculate late rate for related controls.')
  }
}
export const getsecurityControlstByActionIdApi = async (ActionId: string) => {
  try {
    const response = await instanceAxios.get<SecurityControls[]>(
      `actions/getSecurityControls/` + ActionId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch securityCheckFamilys.')
  }
}

export const updateSecurityCintrolsApi = async (
  updateSecurityControl: SecurityControls,
  _id: string
): Promise<SecurityControls> => {
  try {
    const hasFile = updateSecurityControl.file instanceof File

    if (hasFile) {
      const formData = new FormData()

      Object.entries(updateSecurityControl).forEach(([key, value]) => {
        if (value === undefined || value === null) return

        if (key === 'file' && value instanceof File) {
          formData.append('file', value)
          return
        }

        if (Array.isArray(value)) {
          // Serialize arrays (like RelatedControls) if needed, or append individually
           value.forEach((item) => {
             if(typeof item === 'object') {
                formData.append(`${key}[]`, JSON.stringify(item))
             } else {
                formData.append(`${key}[]`, item)
             }
           })
          return
        }
        
        if (typeof value === 'object'){
             formData.append(key, JSON.stringify(value))
        } else {
             formData.append(key, value as any)
        }
       
      })

      const response = await instanceAxios.put<SecurityControls>(
        `${API_URL}/${_id}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      )
      return response.data
    }

    const response = await instanceAxios.put<SecurityControls>(
      `${API_URL}/${_id}`,
      updateSecurityControl
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUT security.')
  }
}

export const calculateSecurityControlActionsCostsApi = async (
  SecurityCheckId: string
) => {
  try {
    const response = await instanceAxios.get<SecurityCheckResponse>(
      `securityControls/calculateSecurityControlActionsCosts/` + SecurityCheckId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to calculate calculateSecurityControlActionsCosts.')
  }
}

export const calculateAverageActionsForSecurityControlApi = async (
  SecurityCheckId: string
): Promise<SecurityCheckResponse> => {
  try {
    const response = await instanceAxios.get<SecurityCheckResponse>(
      `securityControls/calculateAverageActionsForSecurityControl/` +
        SecurityCheckId
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error('Failed to  calculateSecurityControlActionsCosts')
  }
}
export const calculateAverageCostForSecurityControlApi = async (
  id: string
): Promise<SecurityControlResponse> => {
  try {
    const response = await instanceAxios.get<SecurityControlResponse>(
      `securityControls/calculateAverageCostForSecurityControl/${id}`
    )
    console.log(response.data)
    return response.data
  } catch (error) {
    throw new Error(
      'Failed to calculate average cost for the security control.'
    )
  }
}
export const getSecurityControlsBySource = async (
  source: 'NIST' | 'NIS2' | 'SAMA' | 'SWIFT',
  page = 1,
  pageSize = 10,
  language?: string
): Promise<securityControlResponse> => {
  try {
    const response = await instanceAxios.get<securityControlResponse>(
      `${API_URL}/by${source}Source`,
      {
        params: { page, pageSize, language },
      }
    )
    return response.data
  } catch (error) {
    throw new Error(`Failed to fetch security controls by ${source} source.`)
  }
}

export const getSecurityControlByLabelApi = async (
  label: string
): Promise<SecurityControls> => {
  try {
    const response = await instanceAxios.get<SecurityControls>(
      `${API_URL}/byLabel`,
      {
        params: { label },
      }
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch security control by label.')
  }
}

// New API functions for the count endpoints
export const countOtherActionsForSecurityControl = async (
  id: string
): Promise<CountOtherActionsForSecurityControlResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: CountOtherActionsForSecurityControlResponse
    }>(`${API_URL}/countOtherActionsForSecurityControl/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to count other actions for security control.')
  }
}

export const countOtherActionsForRelatedControls = async (
  id: string
): Promise<CountOtherActionsForRelatedControlsResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: CountOtherActionsForRelatedControlsResponse
    }>(`${API_URL}/countOtherActionsForRelatedControls/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to count other actions for related controls.')
  }
}

export const countInProgressActionsForSecurityControl = async (
  id: string
): Promise<CountInProgressActionsForSecurityControlResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: CountInProgressActionsForSecurityControlResponse
    }>(`${API_URL}/countInProgressActionsForSecurityControl/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to count in-progress actions for security control.')
  }
}

export const countDoneActionsForSecurityControl = async (
  id: string
): Promise<CountDoneActionsForSecurityControlResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: CountDoneActionsForSecurityControlResponse
    }>(`${API_URL}/countDoneActionsForSecurityControl/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to count done actions for security control.')
  }
}

export const countDoneActionsForRelatedControls = async (
  id: string
): Promise<CountDoneActionsForRelatedControlsResponse> => {
  try {
    const response = await instanceAxios.get<{
      data: CountDoneActionsForRelatedControlsResponse
    }>(`${API_URL}/countDoneActionsForRelatedControls/${id}`)
    return response.data.data
  } catch (error) {
    throw new Error('Failed to count done actions for related controls.')
  }
}

